import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "locales";
import useAuthUser from "hooks/useAuthUser";
import { removeLoginData } from "lib/authHelper";
import providers from "lib/providers";
import { parseErrors } from "lib/requestHelpers";
import BaseButton from "components/BaseButton";
import BaseCard from "components/BaseCard";
import BaseInput from "components/BaseInput";
import ModalWindow from "components/ModalWindow";
import { Routes } from "../../router/config";
import "./style.scss";

export default function PageDeleteAccount() {
  const { t } = useTranslation();
  const { user } = useAuthUser();
  const history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onDelete = async () => {
    if (!user || !password.trim()) return;
    setLoading(true);
    setError("");
    try {
      await providers.UserProvider.delete({ data: { id: user.id, password } });
      removeLoginData();
      history.replace(Routes.home);
    } catch (e: any) {
      const errors = e?.errors;
      if (errors) {
        const parsed = parseErrors(errors);
        setError(parsed.password || parsed.common || t("Incorrect password"));
      } else {
        setError(t("Incorrect password"));
      }
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    setShowModal(false);
    setPassword("");
    setError("");
  };

  return (
    <>
      <BaseCard>
        <div className="page-delete-account">
          <h2 className="headline-2 mb-5">{t("Delete account")}</h2>
          <div className="body">
            <p>{t("Once you delete your account, all your data will be permanently removed.")}</p>
            <p className="mt-3">{t("This action cannot be undone.")}</p>
          </div>
          <BaseButton className="mt-5" large negative onClick={() => setShowModal(true)}>
            {t("Delete account")}
          </BaseButton>
        </div>
      </BaseCard>

      <ModalWindow show={showModal} onClose={onCancel} className="delete-account-modal">
        <div className="delete-account-modal__content">
          <h2 className="headline-2 mb-4">{t("Confirm account deletion")}</h2>
          <p className="body mb-5">{t("Enter your password to confirm account deletion.")}</p>
          <BaseInput
            name="password"
            type="password"
            label={t("Password")}
            placeholder={t("Enter your password")}
            value={password}
            onChange={(val) => {
              setPassword(val);
              setError("");
            }}
            errorMessage={error}
          />
          <div className="delete-account-modal__buttons mt-6">
            <BaseButton large outline onClick={onCancel}>
              {t("Cancel")}
            </BaseButton>
            <BaseButton large negative loading={loading} disabled={!password.trim()} onClick={onDelete}>
              {t("Delete")}
            </BaseButton>
          </div>
        </div>
      </ModalWindow>
    </>
  );
}
